import styled, { css } from 'styled-components'
import {
  anatomyV2ContentWrapperCss,
  anatomyV2RootCss,
} from '~/pages/anatomyV2/libs/pageLayoutStyles'
import { Button } from '~/shared/components/Button'
import { COLORS } from '~/shared/constants/uiConstants'

export const InfoRevealTemplateStyles = {
  Root: styled.div`
    ${anatomyV2RootCss}
    overflow: hidden;
  `,

  ContentWrapper: styled.div`
    ${anatomyV2ContentWrapperCss}
    min-height: 0;
  `,

  ScrollContent: styled.div`
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    padding: 16px;
  `,

  Image: styled.img<{ $isCompact?: boolean }>`
    width: 100%;
    object-fit: cover;
    margin-top: 24px;

    ${({ $isCompact }) =>
      $isCompact
        ? css`
            max-height: 220px;
            border-radius: 30px;
            background-color: #96caec;
            margin-bottom: 16px;
          `
        : css`
            max-height: 300px;
            border-radius: 24px;
            margin-bottom: 24px;
          `}
  `,

  Title: styled.h1`
    font-size: 22px;
    font-weight: 700;
    line-height: 1.1;
    color: ${COLORS.BLACK};
    margin-bottom: 16px;
  `,

  Paragraph: styled.p`
    font-size: 14px;
    line-height: 20px;
    color: ${COLORS.BLACK};

    &:not(:last-of-type) {
      margin-bottom: 24px;
    }
  `,

  ButtonWrapper: styled.div`
    width: 100%;
    padding: 16px;
  `,

  StyledButton: styled(Button)`
    width: 100%;
  `,
}
